import React from 'react';
import {
    withStyles,
    ButtonBase,
    Grid,
    withRouter
} from '../../material-ui';
import './MEnvelope.css'
import IMEventEmitter, { IMEvent } from '../../net/IMEventEmitter';
import AppData from '../../model/AppData';
import FIMUtils from '../../im/FIMUtils';
import ToName from '../../control/ToName';
import DateUtils from '../../control/dateutils';

const ICON_MSG = require("../../images/icons/sixin_icon1.png");

class MEnvelope extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            newMessage: [],
        }
    }

    componentDidMount() {
        IMEventEmitter.on(IMEvent.UPDATE_CONVERSATION_LIST, this.getConversations, this);
        //暴露方法给ios
        window.showEnvelope = this.showEnvelope.bind(this);
    }

    componentWillUnmount() {
        this.setState = () => false;
        IMEventEmitter.off(IMEvent.UPDATE_CONVERSATION_LIST, this.getConversations, this);
        // IMEventEmitter.off(IMEvent.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
    }

    //ios要调用的方法
    showEnvelope = () => {
        this.setState({ show: true, newMessage: ['1', '2'] });
    }

    onMessageReceived = (event) => {
        console.log('onMessageReceived', event)
        if (event.length == 0) return;
        let msgTime = event[0].msgtime * 1000;
        let nowTime = DateUtils.getCurTime();
        if (nowTime - msgTime > 20 * 1000 * 1000) {
            this.setState({ show: true, newMessage: event });
        }


    }
    getConversations = async () => {
        let result = await FIMUtils.getConversationList();
        if (result.length == 0) return;
        let msg = result[0].lastMessage;

        if (msg.uid == AppData.me.chat_id || msg.msgtype != 1) {
            //如果是自己的id
            return;
        }
        console.log(result);
        let msgTime = msg.msgtime;


        let nowTime = DateUtils.getCurTime();
        nowTime = parseInt(nowTime / 1000)

        if (nowTime - msgTime < 30) {
            window.scroll(0, 0);
            this.setState({ show: true, newMessage: result });
        }


    }


    _onClickMessage() {
        let { os } = this.props.match.params;
        if (os == "ios") {
            window.webkit.messageHandlers.JumpMessageList.postMessage('');
        } else { 
            ToName(this.props, "/chat/1")
        }

    }


    render() {
        const { bottom } = this.props;
        const { newMessage } = this.state;
        if (newMessage.length == 0) {
            return <></>;
        }
        return (
            <Grid style={{
                backgroundColor: 'transparent',

            }}>
                <ButtonBase disableRipple onClick={() => this._onClickMessage()}>
                    <img src={ICON_MSG} className='EnvelopeImg' style={{ width: 50, height: 50 }}></img>
                </ButtonBase>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => ({

}))(MEnvelope));
